import React from 'react';
import PropTypes from 'prop-types';

export default function (ComposedComponent) {
  return class Authenticate extends React.Component {

    static propTypes = {
      viewer: PropTypes.object
    };

    componentDidMount() {
      if (!this.props.viewer) {
        window.location = '/login';
      }
    }

    render() {
      return (
        <div>
          {this.props.viewer ? <ComposedComponent {...this.props} /> : null}
        </div>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./webpack/components/App/Authenticate.js